import Alerts from 'lib/alerts';
import SignupFormView from 'commons/views/SignupForm';
import PasswordRuleTableView from 'commons/views/PasswordRuleTable';
import Cookies from 'js-cookie';
import queryString from 'query-string';
import _ from 'underscore';
import User from 'newModels/user.js';
import config from 'config';
import LogosRatingsTemplate from '../templates/LogosRatings.html';

module.exports = SignupFormView.extend({
    el: '.content',

    passwordRuleTableView: null,

    events() {
        return Object.assign(SignupFormView.prototype.events.apply(this), {
            'submit .js-signup-form': 'signUp',
            'click .js-go-to-top': 'goToTop',
            'keyup input[name="password"]': 'toggleRuleDisplay',
            'click .js-sign-up-with-xero-button': 'signUpWithXero'
        });
    },

    initialize(options) {
        this.record = options.record || null;
        this.params = queryString.parse(window.location.search);

        var pageDesc = '';

        this.options = _.extend(options, {
            adConversionParams: options.query || {}
        });

        // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
        var coupon = this.options.adConversionParams.utm_term ||
            this.options.adConversionParams.cpn;
        // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
        if (
            coupon &&
            !Cookies.get('couponCode')
        ) {
            Cookies.set('couponCode', coupon, {expires: 30});
        }

        // Hammer, meet balls. Balls, meet hammer.
        var _w = window;
        this.lang = 'en';
        if (_w.location.hash.indexOf('#signup-page-1-partner') > -1) {
            this.template = require('../templates/SignUp-Partner.html');
            document.title = 'Sign Up Online Payroll Software | PayrollPanda';
            pageDesc = 'Sign up for affordable & easy-to-use online payroll ';
            pageDesc += 'software. Includes free leave management. ';
            pageDesc += 'Try us now and run two payrolls FREE!';
        } else if (_w.location.hash.indexOf('#signup-page-1') > -1) {
            this.template = require('../templates/SignUp-Fb.html');
            document.title = 'Sign Up Online Payroll Software | PayrollPanda';
            pageDesc = 'Sign up for affordable & easy-to-use online payroll ';
            pageDesc += 'software. Includes free leave management. ';
            pageDesc += 'Try us now and and run your first payroll for FREE!';
        } else if (_w.location.hash.indexOf('#signup-page-2') > -1) {
            this.template = require('../templates/SignUp-Leave.html');
            document.title = 'Leave Management System | PayrollPanda';
            pageDesc = 'Sign up for affordable & easy-to-use online leave ';
            pageDesc += 'system. Includes payroll software. Try us now ';
            pageDesc += 'and run your first payroll for FREE!';
        } else if (_w.location.hash.indexOf('#signup-page-3') > -1) {
            this.template = require('../templates/SignUp-Leave-3.html');
            document.title = 'Sign Up Payroll System | PayrollPanda';
            pageDesc = 'Sign up for affordable & easy-to-use online ';
            pageDesc += 'payroll system. Includes free leave management. ';
            pageDesc += 'Try us now and run your first payroll for FREE!';
        } else if (_w.location.hash.indexOf('#signup-page-4') > -1) {
            this.template = require('../templates/SignUp-Leave-4.html');
            document.title = 'Free Payroll Software | PayrollPanda';
            pageDesc = 'Sign up for affordable & easy-to-use online ';
            pageDesc += 'payroll software. Includes free leave ';
            pageDesc += 'management. Try the payroll software for FREE!';
        } else if (_w.location.hash.indexOf('#signup-page-5') > -1) {
            this.template = require('../templates/SignUp-Leave-5.html');
            document.title = 'Online Payroll Service | PayrollPanda';
            pageDesc = 'Sign up for affordable & easy-to-use online ';
            pageDesc += 'payroll service. Includes free leave management. ';
            pageDesc += 'Try us now and run your first payroll for FREE!';
        } else if (_w.location.hash.indexOf('#signup-page-6') > -1) {
            this.template = require('../templates/SignUp-Leave-6.html');
            document.title = 'Online HR Management Software | PayrollPanda';
            pageDesc = 'Sign up for affordable & easy-to-use HR ';
            pageDesc += 'Management Software. Includes leave ';
            pageDesc += 'management. Try us now and run your first ';
            pageDesc += 'payroll for FREE!';
        } else if (_w.location.hash.indexOf('#signup-page-my-1') > -1) {
            this.lang = 'ms';
            this.template = require('../templates/SignUp-My-Fb.html');
            document.title = 'Sign Up Online Payroll Software | PayrollPanda';
            pageDesc = 'Sign up for affordable & easy-to-use online payroll ';
            pageDesc += 'software. Includes free leave management. ';
            pageDesc += 'Try us now and and run your first payroll for FREE!';
        } else {
            this.template = require('../templates/SignUp.html');
            document.title = 'Get Online Payroll System | PayrollPanda';
            pageDesc = 'Online HR and Payroll System for Businesses ';
            pageDesc += 'in Malaysia. Simple, Secure, Accurate and ';
            pageDesc += 'Affordable. Includes Free Leave Management. ';
            pageDesc += 'Try it now.';
        }

        document.getElementsByName('description')[0].content = pageDesc;

        this.passwordRuleTableView = new PasswordRuleTableView();

        return SignupFormView.prototype.initialize.apply(this);
    },

    toggleRuleDisplay: function(ev) {
        return this.passwordRuleTableView &&
            this.passwordRuleTableView.toggleRuleDisplay &&
            this.passwordRuleTableView.toggleRuleDisplay(ev);
    },

    determineRole: function() {
        if (this.record && this.record.data) {
            if (this.record.data.role === undefined && this.record.data.employeeId) {
                return 'employee';
            }
            return this.record.data.role;
        }

        return 'employer';
    },

    render: function() {
        const recordEmail = (this.record ? this.record.data.email : '').trim();
        const recordName  = (this.record ? this.record.data.name : '').trim();
        let who = 'Employer';

        const role = this.determineRole();
        if (role === 'employee') {
            who = 'Employee';
        } else if (role === 'mpp_admin') {
            who = 'MPP Admin';
        } else if (role === 'mpp_manager') {
            who = 'MPP Manager';
        }
        if (this.record && this.record.data) {
            this.model.set({
                email: (recordEmail || '').toLowerCase(),
                name: recordName,
                role,
                isMPPCustomer: role === 'employer'
            }, {validate: false});
        }

        this.$el.html(this.template({
            restrictEmployerSignup: !this.record,
            email: (recordEmail || '').toLowerCase(),
            name: recordName,
            who: who,
            contactPhoneRequired: (
                role === 'employer' &&
                !this.record
            )
        }));

        $('body').addClass('gray-bg');
        this.$('[name=password]').pwstrength({
            ui: {
                showVerdicts: false,
                colorClasses: [
                    'danger',
                    'warning',
                    'warning',
                    'info',
                    'info',
                    'success'
                ]
            },
            common: {minChar: 8}
        });

        $('#section-ratings').html(LogosRatingsTemplate({
            lang: this.lang
        }));

        if (this.record) {
            this.$('ul.nav.nav-tabs>li:first-child>a')
                .attr('data-toggle', null)
                .attr('href', null);
        }

        this.$('#password-rules').append(
            this.passwordRuleTableView.render().$el
        );
    },

    signUp: function(ev) {
        ev.preventDefault();

        if (!this.model.isValid()) {
            this.invalid(this.model, {errors: this.model.validationError});
            return;
        }

        const payload = {
            name: this.model.get('name'),
            email: this.model.get('email'),
            password: this.model.get('password'),
            disclosedEmployeeCount: this.model.get('disclosedEmployeeCount')
        }

        if (this.record) {
            payload.token = this.record.token;
        }
        if (this.model.get('contactPhone')) {
            payload.contactPhone = this.model.get('contactPhone');
        }
        return User.signUp(payload)
            .then(() => this.model.login({
                email: payload.email,
                password: payload.password
            }))
            .then(() => {
                app.reload();
            })
            .catch(err => {
                Alerts.show('error', {
                    title: 'An error ocurred trying to sign up',
                    text: err
                });
            });
    },

    signUpWithXero: function (e) {
        e.preventDefault();
        window.location.href = `${config.apiUrl}/Integrations/xero/signupUrl`;
        return false;
    },

    goToTop: function() {
        $('html, body').animate({scrollTop: 0}, 500, () => {
            this.$('[name="name"]').focus();
        });
    },

    // make sure that whenever we get the email field from the UI we make it
    // lower case
    getInputValueOfEmail: function($el) {
        return ($el.val() || '').trim().toLowerCase();
    }
});



// WEBPACK FOOTER //
// ./app/views/SignUp.js